import {Component, EventEmitter, OnDestroy, OnInit, Output, Inject, ViewChild} from '@angular/core';
import {
  empOrParticipantTableSubHeader,
  ManageEmpOrParticipantHeader
} from '../../models/manage-employees-table-header';
import {Subscription} from 'rxjs';
import {SharedService} from '../../shared.service';
import {FormBuilder, FormGroup} from '@angular/forms';
import {SharedConstant} from '../../constants/sharedConstants';
import {ManageEmployeeDataService} from '../../services/manage-employee/manage-employee-data.service';
import {LazyLoadDropdownComponent} from '../lazy-load-dropdown/lazy-load-dropdown.component';

@Component({
  selector: 'ems-manage-employees-sub-header',
  templateUrl: './manage-employees-sub-header.component.html'
})
export class ManageEmployeesSubHeaderComponent implements OnInit, OnDestroy {

  @Output() hasGroupPlanValue = new EventEmitter<any>();
  @Output() hasShowRecordVal = new EventEmitter<any>();
  @Output() subHeaderFormObj = new EventEmitter<any>();

  public empAccntTblSubHeader: ManageEmpOrParticipantHeader = empOrParticipantTableSubHeader;

  empListSubHeaderForm!: FormGroup;
  currentOrgSubscription!: Subscription;
  clearClickedSubscription!: Subscription;
  sharedConstant = SharedConstant;
  grpOrPlanSearchVal = '';
  nameDropdownInpVal: string | number | null = null;
  empAccSubHeaderCols: any[] = [];
  getOrgId: any;
  @ViewChild('groupPlanDropdown') groupPlanDropdown?: LazyLoadDropdownComponent;

  constructor(private fb: FormBuilder, public sharedService: SharedService, public manageEmployeeDataService: ManageEmployeeDataService,
              @Inject('entitlementConst') public entitlementConst: any) {
  }

  ngOnInit() {
    this.empListSubHeaderForm = this.fb.group({
      empGroupName: '',
      showRecords: this.sharedConstant.showRecords[0]
    });


    /* Set 'Active' as default value for Show Records dropdown */
    const showRecorValue = this.sharedConstant.showRecords[0];
    this.empListSubHeaderForm.get('showRecords')?.setValue(showRecorValue);
    
    this.currentOrgSubscription = this.sharedService.clientInformation.subscribe((clientInfo: any) => {
      if (clientInfo !== null) {
        this.getOrgId = clientInfo.orgId;
        this.grpOrPlanSearchVal = this.nameDropdownInpVal = '';
        this.empAccSubHeaderCols = this.empAccntTblSubHeader[clientInfo.businessUnit as keyof ManageEmpOrParticipantHeader] as any[];
        this.sharedService.businessUnit = clientInfo.businessUnit;
        if (this.getOrgId !== 0 && this.manageEmployeeDataService.filterToggleClicked) {
          /* selectedGroupAndPlanNameInEmpGroup value will be set in 2 places --> 1. in employee groups/plans page when No. Of Accounts link is clicked.
          2. When value is selected in group name filter on employee/participants page (This is done to hold on to the selected value when user simply closes and re-opens the filter toggle) */
          if (this.sharedService.selectedGroupAndPlanNameInEmpGroup) {
            this.nameDropdownInpVal = this.sharedService.selectedGroupAndPlanIdInEmpGroup;
            this.sharedService.selectedGroupOrPlanName = this.sharedService.selectedGroupAndPlanNameInEmpGroup;
            const name = this.sharedService.selectedGroupAndPlanNameInEmpGroup ? this.sharedService.selectedGroupAndPlanNameInEmpGroup : this.nameDropdownInpVal ? this.nameDropdownInpVal : 'All';
            this.empListSubHeaderForm.get('empGroupName')?.setValue(name);
            const localUpdatedFormValues = this.empListSubHeaderForm.getRawValue();
            /* Call Apply filter in parent only if navigating from Manage Employee Groups/Plans page using no. of account
            link (this condition is added to avoid making the api call when Apply button is not clicked) */
            if (this.sharedService.navFromGrpOrPlan) {
              this.hasGroupPlanValue.emit(this.nameDropdownInpVal);
              this.subHeaderFormObj.emit({empListSubHeaderForm: localUpdatedFormValues});
              this.sharedService.navFromGrpOrPlan = false;
            }
            this.manageEmployeeDataService.filterToggleClicked = false;
          } else {
            this.manageEmployeeDataService.filterToggleClicked = false;
          }
        }
        this.grpOrPlanSearchVal = '';
      } else {
        this.nameDropdownInpVal = null;
      }
      if(!this.sharedService.selectedGroupAndPlanIdInEmpGroup){
        this.nameDropdownInpVal=null;
      }
    });

    this.clearClickedSubscription = this.manageEmployeeDataService.clearClicked.subscribe(val => {
      if (val) {
        this.clearFilterForm();
      }
    });
    
    this.empListSubHeaderForm.get('showRecords')?.valueChanges.subscribe(value => {
      if (value) {
        this.hasShowRecordVal.emit(value);
      }
    });
  }

  groupNameUpdated(event?: any) {
    const selectedValue = event?.selectedItem;
    const selectedId = event?.id ?? null;
    const selectedType = event?.type || '';
    this.empListSubHeaderForm.get('empGroupName')?.setValue(selectedValue || 'All');

    if (!selectedValue || selectedValue === this.sharedConstant.groupNameAll) {
      this.nameDropdownInpVal = null;
      this.sharedService.selectedGroupAndPlanNameInEmpGroup = '';
      this.sharedService.selectedGroupAndPlanIdInEmpGroup = '';
      this.sharedService.selectedGroupAndPlanIdType = '';
      this.hasGroupPlanValue.emit(this.nameDropdownInpVal);
      return;
    }

    this.sharedService.selectedGroupAndPlanNameInEmpGroup = selectedValue;
    this.nameDropdownInpVal = selectedId;
    this.sharedService.selectedGroupAndPlanIdInEmpGroup = selectedId || '';
    this.sharedService.selectedGroupAndPlanIdType = selectedType;
    this.hasGroupPlanValue.emit(this.nameDropdownInpVal);
  }

  applyPersistedGroupPlanSelection() {
    const selectedOption = this.groupPlanDropdown?.getSelectedEmployeeGroupOption();
    if (selectedOption) {
      this.groupNameUpdated({selectedItem: selectedOption.value, id: selectedOption.id, type: selectedOption.type});
      return;
    }

    const groupName = this.sharedService.selectedGroupAndPlanNameInEmpGroup || this.sharedService.selectedGroupOrPlanName;
    if (groupName) {
      this.groupNameUpdated({selectedItem: groupName});
    }
  }

  clearFilterForm(): void {
    this.empListSubHeaderForm.reset();
    this.empListSubHeaderForm.get('showRecords')?.setValue(this.sharedConstant.showRecords[0]);
   /* After Click on clear value the default value should coming as all*/
    this.nameDropdownInpVal = null;
    this.grpOrPlanSearchVal = '';
    this.sharedService.selectedGroupAndPlanNameInEmpGroup = '';
    this.sharedService.selectedGroupAndPlanIdInEmpGroup = '';
    this.sharedService.selectedGroupAndPlanIdType = '';
    this.sharedService.selectedGroupOrPlanName = '';
    const groupDropdownRef: any = this.groupPlanDropdown;
    if (groupDropdownRef && typeof groupDropdownRef.resetDropdown === 'function') {
      groupDropdownRef.resetDropdown();
    }
    this.hasGroupPlanValue.emit(this.nameDropdownInpVal);
    this.hasShowRecordVal.emit('');
  }

  ngOnDestroy(): void {
    if (this.currentOrgSubscription) {
      this.currentOrgSubscription.unsubscribe();
    }
    if (this.clearClickedSubscription) {
      this.clearClickedSubscription.unsubscribe();
    }
  }

}
